<div class="upgrade-preview-cta">
  <div class="upgrade-preview-copy">
    <div class="upgrade-preview-title">{{ title }}</div>
    <div class="upgrade-preview-description">{{ description }}</div>
    <div class="upgrade-preview-hidden" *ngIf="hiddenRowsCount > 0">
      <mat-icon>more_horiz</mat-icon>
      <span>{{ hiddenRowsCount }} more rows hidden</span>
    </div>
  </div>

  <button
    mat-raised-button
    class="upgrade-preview-button"
    (click)="onCtaClick()"
  >
    <mat-icon>lock_open</mat-icon>
    <span>{{ buttonLabel }}</span>
  </button>
</div>
